var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feet",class:{
    'facing-right': _vm.facing === 'right'  
  }},[_c('div',{staticClass:"feet__left"}),_c('div',{staticClass:"feet__right"})])}
var staticRenderFns = []

export { render, staticRenderFns }